import { render } from "./StaffMgt.vue?vue&type=template&id=57554f6e&scoped=true"
import script from "./StaffMgt.vue?vue&type=script&lang=js"
export * from "./StaffMgt.vue?vue&type=script&lang=js"

import "./StaffMgt.vue?vue&type=style&index=0&id=57554f6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57554f6e"]])

export default __exports__